import { TApplicationState } from '../../types/redux';

export function getIsUpcomingSale(state: TApplicationState): boolean {
  return state.newbuilding.isUpcomingSale || false;
}
